import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7bd37ba3")
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "type-list" }
const _hoisted_4 = { class: "resoure-detail" }
const _hoisted_5 = { class: "r-name" }
const _hoisted_6 = { class: "r-location" }
const _hoisted_7 = { class: "distance" }
const _hoisted_8 = { class: "r-time" }
const _hoisted_9 = { class: "f-detail" }
const _hoisted_10 = { class: "init-info" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "address" }, null, -1)
const _hoisted_13 = { class: "resoures-data" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E8%92%99%E7%89%88%E7%BB%84%2071%402x.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "tips-introduce" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "name" }, "资源数据"),
    /*#__PURE__*/_createElementVNode("div", { class: "introduce" }, "基地种植基本信息")
  ])
], -1)
const _hoisted_15 = { class: "t-box" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "种植品种", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, "地区", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, "面积", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "预计产量", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, "上市时间", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, "供应周期", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "备注", -1)
const _hoisted_23 = { class: "farming" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "农事动态", -1)
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 506@2x.png",
    alt: ""
  })
], -1)
const _hoisted_27 = { class: "farming-records" }
const _hoisted_28 = { class: "line1" }
const _hoisted_29 = { class: "medi-font" }
const _hoisted_30 = { class: "line2 litt-font" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "video-wrap" }
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  class: "play-video",
  src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/128%402x.png"
}, null, -1)
const _hoisted_35 = { class: "durations medi-font" }
const _hoisted_36 = {
  key: 1,
  class: "line4"
}
const _hoisted_37 = { class: "zan-com" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://qnui.xfarmer.com/xfarmer-ui/farmerComments/1259@2x.png",
  alt: ""
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://qnui.xfarmer.com/xfarmer-ui/farmerComments/1260_@2x.png",
  alt: ""
}, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image_preview = _resolveComponent("van-image-preview")!
  const _component_preview_video = _resolveComponent("preview-video")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createBlock(_component_van_list, {
    loading: _ctx.loading,
    "onUpdate:loading": _cache[9] || (_cache[9] = ($event: any) => (_ctx.loading = $event)),
    finished: _ctx.finished,
    "finished-text": "没有更多了",
    onLoad: _ctx.onLoad,
    style: {"background":"#fff"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "img-box",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toVideoImage(_ctx.initInfo.vrImg.length != 0 ? 1 : 3))),
            style: _normalizeStyle(`background: url('${_ctx.backgroundImg}');`)
          }, [
            (_ctx.initInfo.vrImg.length != 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "logo",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toVideoImage(1))),
                  src: "https://qnui.xfarmer.com/xfarmer-ui/trace/720@2x.png"
                }))
              : _createCommentVNode("", true),
            (
              _ctx.initInfo.vrImg.length == 0 &&
              _ctx.initInfo.dataImgs.length == 0 &&
              _ctx.initInfo.video.length != 0
            )
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "logo",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toVideoImage(3))),
                  src: "https://qnui.xfarmer.com/xfarmer-ui/trace/监控@2x.png"
                }))
              : _createCommentVNode("", true),
            (_ctx.initInfo.vrImg.length == 0 && _ctx.initInfo.dataImgs.length != 0)
              ? (_openBlock(), _createBlock(_component_van_swipe, {
                  key: 2,
                  "show-indicators": false,
                  class: "my-swipe",
                  style: {"height":"10rem","width":"20rem"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initInfo.dataImgs, (item) => {
                      return (_openBlock(), _createBlock(_component_van_swipe_item, {
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_image, {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toVideoImage(2)), ["stop"])),
                            fit: "cover",
                            width: "20rem",
                            height: "10rem",
                            src: item.url
                          }, null, 8, ["src"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_3, [
              (_ctx.initInfo.vrImg.length != 0)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "active",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.toVideoImage(1)), ["stop"]))
                  }, " VR "))
                : _createCommentVNode("", true),
              (_ctx.initInfo.dataImgs.length != 0)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: "active",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.toVideoImage(2)), ["stop"]))
                  }, " 照片 "))
                : _createCommentVNode("", true),
              (_ctx.initInfo.video.length != 0)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 2,
                    class: "active",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.toVideoImage(3)), ["stop"]))
                  }, " 视频 "))
                : _createCommentVNode("", true)
            ])
          ], 4),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.initInfo.sourceName), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.initInfo.addressInfo), 1),
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_van_icon, { name: "location-o" }),
                _createTextVNode(_toDisplayString(_ctx.initInfo.distance) + "km", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, "资源编号:" + _toDisplayString(_ctx.initInfo.sourceId), 1)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "farmer",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toFarmer && _ctx.toFarmer(...args)))
        }, [
          _createElementVNode("div", {
            class: "img-box",
            style: _normalizeStyle(`background: url('${
            _ctx.initInfo.farmerHeadImg.length != 0
              ? _ctx.initInfo.farmerHeadImg[0].url
              : 'https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E7%BB%84%20989%402x.png'
          }');`)
          }, null, 4),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.initInfo.farmerName), 1)
            ]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("table", null, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_16,
                  _createElementVNode("td", null, _toDisplayString(_ctx.initInfo.sourceTypeName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_17,
                  _createElementVNode("td", null, _toDisplayString(_ctx.initInfo.typeAddress), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", null, _toDisplayString(_ctx.initInfo.plantArea) + "亩", 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_19,
                  _createElementVNode("td", null, _toDisplayString(_ctx.initInfo.yield) + "斤", 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _createElementVNode("td", null, _toDisplayString(_ctx.initInfo.launchDate), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_21,
                  _createElementVNode("td", null, _toDisplayString(_ctx.initInfo.supplyCycle) + "天", 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_22,
                  _createElementVNode("td", null, _toDisplayString(_ctx.initInfo.remark), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "reco",
              onClick: ($event: any) => (_ctx.toDetail(item.id)),
              key: item.id
            }, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(item.workTime), 1)
                ]),
                _createElementVNode("div", _hoisted_30, _toDisplayString(item.remark), 1),
                (item.videos.length != 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "line3",
                      onClick: ($event: any) => (_ctx.playVideo(item.videos[0].url))
                    }, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("img", {
                          src: item.videos[0].coverImg
                        }, null, 8, _hoisted_33),
                        _hoisted_34,
                        _createElementVNode("span", _hoisted_35, _toDisplayString(item.videos[0].time), 1)
                      ])
                    ], 8, _hoisted_31))
                  : _createCommentVNode("", true),
                (item.images.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (value) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "img-wrap",
                          key: value.id
                        }, [
                          _createVNode(_component_van_image, {
                            class: "imgs",
                            radius: "0.625rem",
                            width: "5.5rem",
                            height: "5.5rem",
                            fit: "cover",
                            onClick: ($event: any) => (_ctx.previewImage(item.id, value.id)),
                            src: value.url + '?imageView2/1/w/200/h/200/rotate/0'
                          }, null, 8, ["onClick", "src"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", null, [
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(item.allZan), 1)
                  ]),
                  _createElementVNode("span", null, [
                    _hoisted_39,
                    _createTextVNode(" " + _toDisplayString(item.allComment), 1)
                  ])
                ])
              ])
            ], 8, _hoisted_25))
          }), 128))
        ]),
        _createVNode(_component_van_image_preview),
        _createVNode(_component_preview_video, {
          visible: _ctx.showVideos,
          "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.showVideos = $event)),
          url: _ctx.videoUrl,
          autoplay: ""
        }, null, 8, ["visible", "url"])
      ])
    ]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"]))
}